import React from 'react';

// Utility to format date from 'YYYY-MM-DD+05:30' to 'DD/MM/YYYY'
const formatDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    const cleanDate = dateStr.split('+')[0];
    const d = new Date(cleanDate);
    if (isNaN(d.getTime())) return dateStr;
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  } catch {
    return dateStr;
  }
};

// Utility to format amount to Indian Rupee format
const formatCurrency = (val) => {
  if (!val || val === '-1' || val === '') return '₹ 0';
  const num = Number(val);
  if (isNaN(num)) return val;
  return `₹ ${num.toLocaleString('en-IN')}`;
};

// Map inquiry type symbol to description
const getEnquiryPurpose = (symbol) => {
  const map = {
    '01': 'AUTO LOAN',
    '02': 'HOUSING LOAN',
    '03': 'PROPERTY LOAN',
    '04': 'BUSINESS LOAN',
    '05': 'PERSONAL LOAN',
    '06': 'CONSUMER LOAN',
    '08': 'AUTO LOAN (PERSONAL)',
    '99': 'OTHERS'
  };
  return map[symbol] || 'OTHERS';
};

export default function ConsumerEnquiryDetails({ enquiries = [] }) {
  // Demo fallback array if no enquiries are passed as props
  const enquiryList = enquiries.length > 0 ? enquiries : fallbackData;

  return (
    <div className="w-full max-w-5xl mx-auto p-4  custom-font print:p-0 min-h-screen">
      {/* SECTION HEADER */}
      <h2 className="text-2xl font-bold text-gray-900 mb-6 uppercase tracking-wide">
        CONSUMER ENQUIRY DETAILS
      </h2>

      {/* SUB HEADER */}
      <h3 className="text-lg font-bold text-gray-900 mb-2 uppercase tracking-wide">
        ENQUIRIES
      </h3>

      {/* TABLE CONTAINER */}
      <div className="border border-gray-500 rounded-sm overflow-hidden">
        <table className="w-full text-left border-collapse">
          
          {/* TABLE HEAD */}
          <thead>
            <tr className=" border-b border-gray-400">
              <th className="py-4 px-4 text-xs font-bold text-[#008c95] uppercase w-1/4">
                MEMBER NAME
              </th>
              <th className="py-4 px-4 text-xs font-bold text-[#008c95] uppercase w-1/4">
                ENQUIRY DATE
              </th>
              <th className="py-4 px-4 text-xs font-bold text-[#008c95] uppercase w-1/4">
                ENQUIRY PURPOSE
              </th>
              <th className="py-4 px-4 text-xs font-bold text-[#008c95] uppercase w-1/4">
                ENQUIRY AMOUNT
              </th>
            </tr>
          </thead>

          {/* TABLE BODY */}
          <tbody>
            {enquiryList.map((item, index) => {
              const data = item?.Inquiry || {};
              
              return (
                <tr 
                  key={index} 
                  className="odd:bg-[#f3f3f3]   last:border-0"
                >
                  <td className="py-3.5 px-4 text-xs font-bold text-gray-900 uppercase">
                    {/* Falling back to "NOT DISCLOSED" if name is missing to match image layout behavior, though your JSON provides the name */}
                    {data.subscriberName || 'NOT DISCLOSED'}
                  </td>
                  <td className="py-3.5 px-4 text-xs font-bold text-gray-900 uppercase">
                    {formatDate(data.inquiryDate)}
                  </td>
                  <td className="py-3.5 px-4 text-xs font-bold text-gray-900 uppercase">
                    {getEnquiryPurpose(data.inquiryType)}
                  </td>
                  <td className="py-3.5 px-4 text-xs font-bold text-gray-900 uppercase">
                    {formatCurrency(data.amount)}
                  </td>
                </tr>
              );
            })}
            
            {enquiryList.length === 0 && (
              <tr>
                <td colSpan="4" className="py-6 text-center text-gray-800 font-bold bg-[#c4c5c5]">
                  NO ENQUIRIES FOUND
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>
    </div>
  );
}

// Fallback data simulating the layout seen in your provided image
const fallbackData = [
  {
    "Inquiry": {
      "amount": "500000",
      "inquiryType": "06",
      "subscriberName": "NOT DISCLOSED",
      "inquiryDate": "2025-06-02+05:30"
    }
  },
  {
    "Inquiry": {
      "amount": "500000",
      "inquiryType": "06",
      "subscriberName": "NOT DISCLOSED",
      "inquiryDate": "2025-05-31+05:30"
    }
  },
  {
    "Inquiry": {
      "amount": "500000",
      "inquiryType": "05",
      "subscriberName": "BAJAJ FIN LTD", 
      "inquiryDate": "2025-05-29+05:30"
    }
  },
  {
    "Inquiry": {
      "amount": "1000",
      "inquiryType": "05",
      "subscriberName": "NOT DISCLOSED",
      "inquiryDate": "2025-01-08+05:30"
    }
  },
  {
    "Inquiry": {
      "amount": "1",
      "inquiryType": "99",
      "subscriberName": "NOT DISCLOSED",
      "inquiryDate": "2025-01-04+05:30"
    }
  }
];